{
  "common.actions.buscar": {
    "defaultMessage": "Buscar"
  },
  "common.actions.close": {
    "defaultMessage": "Fechar"
  },
  "common.actions.createEntity": {
    "defaultMessage": "common.actions.createEntity"
  },
  "common.actions.edit": {
    "defaultMessage": "common.actions.edit"
  },
  "common.actions.select": {
    "defaultMessage": "Selecionar..."
  },
  "common.actions.selectAll": {
    "defaultMessage": "Selecionar todos"
  },
  "common.actions.selectNone": {
    "defaultMessage": "Selecionar nenhum"
  },
  "common.actions.share": {
    "defaultMessage": "Share"
  },
  "common.actions.view": {
    "defaultMessage": "Ver"
  },
  "common.apiError.body": {
    "defaultMessage": "Tente novamente em alguns segundos. {br}Entre em contato conosco se o erro persistir."
  },
  "common.apiError.title": {
    "defaultMessage": "O servidor não está respondendo"
  },
  "common.confirmationModal.cancelBtnText": {
    "defaultMessage": "Cancelar"
  },
  "common.confirmationModal.confirmBtnText": {
    "defaultMessage": "Confirmar"
  },
  "common.copyBtn.copied": {
    "defaultMessage": "Copied"
  },
  "common.fatalError.body": {
    "defaultMessage": "Tente voltar ao início. Se o problema continuar, entre novamente ou fale conosco."
  },
  "common.fatalError.loginAgainBtn": {
    "defaultMessage": "Entrar"
  },
  "common.fatalError.refreshBtn": {
    "defaultMessage": "Ir ao início"
  },
  "common.fatalError.title": {
    "defaultMessage": "Algo deu errado"
  },
  "common.fileInput.btnText": {
    "defaultMessage": "Selecionar arquivos"
  },
  "common.form.cancelBtnText": {
    "defaultMessage": "Cancelar"
  },
  "common.form.dateRange.endDatePlaceholder": {
    "defaultMessage": "Até"
  },
  "common.form.dateRange.startDatePlaceholder": {
    "defaultMessage": "De"
  },
  "common.form.errorNotification": {
    "defaultMessage": "Ocorreu um erro. {br}Verifique todos os campos e tente novamente"
  },
  "common.form.exitCancelBtnText": {
    "defaultMessage": "Continuar editando"
  },
  "common.form.exitConfirmBtnText": {
    "defaultMessage": "Sair sem salvar"
  },
  "common.form.exitPrompt": {
    "defaultMessage": "Deseja realmente cancelar? {br}Alterações não salvas serão perdidas."
  },
  "common.form.saveBtnText": {
    "defaultMessage": "Salvar"
  },
  "common.form.savedBtnText": {
    "defaultMessage": "Salvo"
  },
  "common.form.updateBtnText": {
    "defaultMessage": "Atualizar"
  },
  "common.form.updatedBtnText": {
    "defaultMessage": "Atualizado"
  },
  "common.languageSelect.defaultLabel": {
    "defaultMessage": "Idioma"
  },
  "common.listFilter.apply": {
    "defaultMessage": "Search"
  },
  "common.listFilter.reset": {
    "defaultMessage": "Reset"
  },
  "common.noResults": {
    "defaultMessage": "common.noResults"
  },
  "common.pagination.countText": {
    "defaultMessage": "Mostrando {showCount, plural, =0 {nenhum item} one {# item} other {# itens}} de {totalCount}"
  },
  "common.reset": {
    "defaultMessage": "Reset"
  },
  "common.text.clear": {
    "defaultMessage": "Limpar"
  },
  "common.timezoneSelect.defaultLabel": {
    "defaultMessage": "Fuso horário"
  },
  "common.viewError.actions.back": {
    "defaultMessage": "Voltar"
  },
  "common.viewError.actions.home": {
    "defaultMessage": "Ir para o início"
  },
  "common.viewError.actions.retry": {
    "defaultMessage": "Tentar novamente"
  },
  "common.viewError.details.toggle": {
    "defaultMessage": "Detalhes técnicos"
  },
  "common.viewError.error.help": {
    "defaultMessage": "Tente novamente. Se o problema continuar, entre em contato."
  },
  "common.viewError.error.title": {
    "defaultMessage": "Não foi possível carregar estas informações"
  },
  "common.viewError.forbidden.help": {
    "defaultMessage": "Se você acha que deveria ter acesso, peça a um administrador."
  },
  "common.viewError.forbidden.title": {
    "defaultMessage": "Você não tem permissão para ver isto"
  },
  "common.viewError.notFound.help": {
    "defaultMessage": "O item não existe ou foi excluído. Verifique o link ou volte para a lista."
  },
  "common.viewError.notFound.title": {
    "defaultMessage": "Não encontramos o que você procurava"
  },
  "common.viewError.unavailable.help": {
    "defaultMessage": "Verifique sua conexão e tente novamente em alguns instantes."
  },
  "common.viewError.unavailable.title": {
    "defaultMessage": "Não foi possível conectar"
  },
  "stream.thumbnails.empty": {
    "defaultMessage": "No hay miniaturas disponibles"
  },
  "stream.thumbnails.loading": {
    "defaultMessage": "Cargando miniaturas"
  }
}
